export function numberSeparator(num: number | string): string {
  if (num) {
    let result: string;
    const n1 = num.toString().split('.');
    const n2 = n1[1] || null;
    result = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, '$1,');
    return n2 ? `${result}.${n2}` : result;
  } else {
    return typeof num === 'number' ? num.toString() : '';
  }
}
